export default __webpack_public_path__ + "static/bg_image_other-8f3a91319b53a7916c400e9169aa707e.webp";